import React from "react";
import Icons from "../../../../Config/Images";
import { tableInputStyle } from "../../../../Utils/CommonStyles/muTableStyle";
import Fonts from "../../../../Config/Fonts";
import Colors from "../../../../theme/Colors";

const ProductPurityTableBody = ({
  purityModDetails,
  onViewProductPurityDetails,
  onEditProductPurityDetails,
  handleShowDeleteModal,
}) => {
  return (
    <tbody>
      {purityModDetails?.map((prod, index) => (
        <tr key={index}>
          <td component="th" style={tableDataInputStyle}>
            {index + 1}
          </td>
          <td component="th" style={tableDataInputStyle}>
            {prod?.product_metal_purity_id || "-"}
          </td>
          <td component="th" style={tableDataInputStyle}>
            {prod?.product_metal_purity_value || "-"}
          </td>
          <td align="right" style={tableDataInputStyle}>
            <img
              src={Icons.viewIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
              }}
              onClick={() => onViewProductPurityDetails(prod)}
              alt="Preview Icon"
            />
            <img
              src={Icons.editIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "20px",
              }}
              onClick={() => onEditProductPurityDetails(prod)}
              alt="edit Icon"
            />
            <img
              src={Icons.trashIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "20px",
              }}
              onClick={() =>
                handleShowDeleteModal(prod.product_metal_purity_id)
              }
              alt="Delete Icon"
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const tableDataInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "8px 20px",
  border: "1px solid #E6E6E6",
};

export default ProductPurityTableBody;
